import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { PackageDataService } from 'src/app/services/package-data.service';
import { DirectionService } from 'src/app/shared/services/direction.service';
import * as _ from "lodash";
import { forkJoin } from 'rxjs';
@Component({
    selector: 'app-view-all-fno-packages',
    templateUrl: './view-all-fno-packages.component.html',
    styleUrls: ['./view-all-fno-packages.component.scss', '../../enroll/components/packages/packages.component.scss']
})
export class ViewAllFnoPackagesComponent implements OnInit {
    serviceProviderId = 0;
    isUltimatePackage: boolean;
    importantProductIdList: any = [];
    selectServiceProviderId: any;
    activeProvider: any;
    notExistProviders = [9, 10, 23, 25, 35]
    contentShow: boolean = false
    modifiedProductIdList: any;
    serviceQueue = []
    ServiceProvidersList:any=[]
    productList: any=[];
    SourceProductList: any=[];
    constructor(private packageDataService: PackageDataService, private direction: DirectionService) { }

    ngOnInit() {
        this.loadServiceQueue()
        this.ExecutionQueue()
    }
    loadServiceQueue() {
        this.serviceQueue.push(
            // this.packageDataService.getModifiedProductList(),
            this.packageDataService.getImportantProductId(),
            this.packageDataService.GetCompleteListOfProduct(0),
            this.packageDataService.GetAllServiceProviderList()
        )

    }
    ExecutionQueue() {
        forkJoin(this.serviceQueue).subscribe((serviceResponse: any) => {
            debugger
            // this.modifiedProductIdList = result.map((item) => {
            //     return item.id;
            // });
            // this.modifiedProductIdList = serviceResponse[0];
            this.importantProductIdList = serviceResponse[0];
            this.ServiceProvidersList = serviceResponse[1].filter(res => !this.notExistProviders.includes(res.serviceProviderId))
            this.activeProvider = serviceResponse[1].serviceProviderId
            this.SourceProductList = serviceResponse[2]

        })

    }
    selectedProviderPackage(item) {
        this.activeProvider = item.serviceProviderId;
        this.FilteredProducts()
    }
    FilteredProducts(){
        debugger
        this.productList = this.ServiceProvidersList.filter(res => res.serviceProviderId == this.activeProvider)
        this.productList.forEach((productItem: any) => {
            debugger
            if (this.importantProductIdList.indexOf(productItem.productId) !== -1) {
                productItem.isImportantProduct = true;
            } else {
                productItem.isImportantProduct = false;
            }
            // this.modifiedProductIdList.forEach((element: any) => {
            //     if (element.id == productItem.productId) {
            //         productItem.isModifiedProduct = true;
            //         productItem.cost = parseInt(element.totalAmount);
            //         productItem.promotionCost = parseInt(element.promotionCost)
            //     }
            // })
        });
        console.log("list---",this.productList);
    }
}
